import { render, staticRenderFns } from "./DoubleImage.vue?vue&type=template&id=75c5fa98&"
import script from "./DoubleImage.vue?vue&type=script&lang=js&"
export * from "./DoubleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports